module.exports = __webpack_public_path__ + "img/menulingua_logo_v2.71d0d828.svg";